var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93608 0.939394C9.17333 0.927825 9.40928 0.980859 9.61876 1.09284C9.82824 1.20482 10.0034 1.37155 10.1256 1.57526C10.2478 1.77897 10.3124 2.01201 10.3125 2.24955V2.25V15.1875H8.8125V2.60067L3.5625 6.10045V15.1875H2.0625V6.00172M8.93608 0.939394C8.69892 0.950958 8.46934 1.02664 8.27181 1.15837ZM9.10406 2.40631C9.10398 2.40636 9.1039 2.40642 9.10382 2.40647Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4375 6.9375H9.5625V5.4375H14.625C14.9731 5.4375 15.3069 5.57578 15.5531 5.82192C15.7992 6.06806 15.9375 6.4019 15.9375 6.75V15.1875H14.4375V6.9375Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.875 15.9375H1.125V14.4375H16.875V15.9375Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5625 9V7.875H8.0625V9H6.5625Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3125 9V7.875H5.8125V9H4.3125Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3125 12.9375V11.8125H5.8125V12.9375H4.3125Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5625 12.9375V11.8125H8.0625V12.9375H6.5625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/Buildings.ff5bcc10e883ce448ab7c8acc886956b.svg";
export { ForwardRef as ReactComponent };